import { orderUrl, statisticsUrl,msgUrl } from '@common/url-conf'

import { post } from '@common/axios'
import qs from 'qs';

export const statisticsApi = {
  // 获取Demo列表
  getDemo: (p, h, op) => post(`${orderUrl}/templateManage/getMsgTemplateList`, p, h, op),

  // 多条件查询站内信 已读 未读 条数
  queryMsgNumMoreCriteria: p => post(`${msgUrl}${statisticsUrl}/queryMsgNumMoreCriteria`, p),
  // 根据字典Code查询所有字典项
  findByCode: p => post(`${msgUrl}/dict/findByCode?${qs.stringify(p)}`),
  // 更新阅读状态
  bathUpdateReadStatus: p => post(`${msgUrl}${statisticsUrl}/bathUpdateReadStatus`, p),
  //站内信条数
  queryMsgNumByModule: p => post(`${msgUrl}${statisticsUrl}/queryMsgNumByModule`, p)
};



// WEBPACK FOOTER //
// ./src/modules/user-center/news/service.js